module.exports = __webpack_public_path__ + "img/gift4-01-c07-y2.a3ea10a8.png";